
import { Component, EventEmitter, OnInit, Output, Injector } from '@angular/core';
import { Stkpi20Component } from './stkpi20Pkg.component';
//import { Stkpi20DetailComponent } from './stkpi20-detailPkg.component';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-stkpi20-bill',
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule, Stkpi20Component],
  templateUrl: './stkpi20BillPkg.component.html',
  styleUrls: [],
})
export class Stkpi20BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' stkpi20'; //###
  override masterPage!: Stkpi20Component;
  //override detailPage!:  Stkpi20DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
